import * as lookup from "../../../static/lookup.json"
import * as moment from "moment"
import { dateFormat1 } from "../../shared/constant"
import * as journeyCodes from "../../../static/page-section-mapper.json"
import { applyComma, lineCapital } from '../../shared/functions'
import { gspDataLayer, gspTransactionDataLayer } from "./helper/dataLayer/gspDataLayer"
import { invest4GDataLayer, invest4GTransactionDataLayer } from "./helper/dataLayer/invest4GDataLayer"
import { gainDataLayer, gainTransactionDataLayer } from "./helper/dataLayer/gainDataLayer"
export const getStateFromCode = (stateCode) => {
    console.log(stateCode)
    const options = lookup["state"][0]
    return options[stateCode]
}

export const getValueFromLookup = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    return lookupKey === "countryCodeToCountry" ? options?.[value] ?? "" : (options?.[value] ?? '') || "NA"
}

export const feetToCms = (feet, inches) => {
    let cms = Math.round((feet * 30.48) + (inches * 2.54))
    return parseInt(cms)
}

export const getValueFromLookup2 = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    return options ? options[value] : "NA"
}

export const getDateInFormat = (dateInEpoch) => {
    return moment.unix(dateInEpoch).utcOffset("+07:30").format(dateFormat1)
}

export const findRiderSA = (riderName, rider) => {
    if (!riderName || !rider || (rider.length === 0)) {
        return "NA"
    }
    let riderIndex = rider.findIndex((element) => element.name === riderName)
    if (riderIndex !== -1) {
        return applyComma(rider?.[riderIndex]?.["ca"] ?? '')
    } else {
        return "NA"
    }
}

export const generateConditonStateString = (planId) => {
    const conditionStateStringProductWise = {
        "FlexiEdgeJourney": "PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails",
        "GuarateedOnePayJourney": "PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails",
        "titaniumPlusJourney": "PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails",
        "alphaWealthPlanJourney": "AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection",
        "guaranteedSavingsOption": "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails",
        "jeevanNivesh": "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails",
        "insureSmart": "PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails",
        "moneyBackAdvantage": "PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails",
        "guaranteedIncomeAdvantage": "PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails",
        "smartJuniorPlan": "PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails",
        "guaranteedFortuneJourney": "PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails",
        "invest4GJourney": "PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails",
        "secureBhavishyaJourney": "PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails",
        "guaranteedIncome4LifeJourney": "PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails",
        "GAINjourney": "GAINcalculatePremiumPage.GAINpersonalDetailsSection",
        "guaranteedFutureJourney": "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails",
        "healthFirstJourney": "PageHealthFirstCalculateFundValue.SectionHealthFirstPersonelDetails"
    }
    return conditionStateStringProductWise[planId];
}

export const findRiderSAPercent = (riderName, rider, lookupKey, percentageName) => {
    if (!riderName || !rider || (rider.length === 0) || percentageName == '' || lookupKey == '') {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    // return options? options[value] : "NA"
    if (!options)
        return 'NA'
    let riderIndex = rider.findIndex((element) => element.name === riderName)
    if (riderIndex !== -1) {
        return options[rider?.[riderIndex]?.[percentageName]] ?? ''
    } else {
        return "NA"
    }
}

export const getAge = (dateInEpoch) => {
    let age = Math.floor(moment(new Date()).diff(moment.unix(dateInEpoch).utcOffset("+05:30"), 'years', true))
    return age
}

export const getLastPageAndLastSection = (currentPageIndex, currentSectionIndex, totalSectionsInCurrentPage) => {
    if (currentSectionIndex + 1 < totalSectionsInCurrentPage) {
        return {
            lastPage: currentPageIndex,
            lastSection: currentSectionIndex + 1
        }
    } else {
        return {
            lastPage: currentPageIndex + 1,
            lastSection: 0
        }
    }
}

export const findCurrentJourneyCode = (pageId, sectionId) => {
    return Object.keys(journeyCodes).find(code => {
        if (journeyCodes[code].pageId === pageId && journeyCodes[code].sectionId === sectionId) {
            console.log(journeyCodes[code], code)
            return code
        }
    })

}
export const getKeyFromValueLookup = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    let channel = "HSBC"
    Object.keys(options).forEach(key => {
        if (options[key] === value) {
            channel = key
        }
    })
    return channel
}

export const productRenderChecker = (valuesInNvest, valueInConditionState) => {
    if (valuesInNvest.includes(",")) {
        let valueArray = valuesInNvest.split(",")
        return valueArray.some(element => element === valueInConditionState)
    } else {
        return valuesInNvest === valueInConditionState
    }
}


export const getValueFromJourney = (lookupKey, value) => {
    if (lookupKey === "" || value === "") {
        return null
    }
    //console.log(lookupKey, value, "check")
    let values = lookupKey?.[0]
    return lookupKey[0] === "countryCodeToCountry" ? values?.[value] ?? "" : (values?.[value] ?? '') || ""
}
export const getRiderInstPrem = (riders, riderName) => {
    if (riders.length === 0) {
        return 0
    }
    if (!riderName) {
        return 0
    }

    let rider = riders.find(element => element.name === riderName)
    return rider?.instPrem || 0
}

export const getRiderInstPremTotal = (riders) => {
    if (riders.length === 0) {
        return 0
    }
    let total = riders.reduce((a, b) => {
        console.log(a, b)
        return a + Number(b.instPrem)
    }, 0)
    return total?.toFixed(2)
}

export const getSourceFromChannel = (channel) => {
    if (!channel) {
        return "I"
    } else if (["A", "C"].includes(channel)) {
        return "I"
    } else {
        let MediaPartnerCodes = lookup["MediaPartnerCode"]
        let foundIndex = MediaPartnerCodes.findIndex(element => element.ITEM_CODE === channel)
        if (foundIndex !== -1) {
            return MediaPartnerCodes[foundIndex]?.SOURCE
        } else {
            return "I"
        }
    }
}

export function stringPath(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    // console.log(a, "a")
    for (var i = 0, n = a.length; i < n; ++i) {

        var k = a[i];
        // console.log(k, "k")
        if (k in o) {
        // console.log("inside if main")
        o = o[k];
        // console.log("inner o", o)
        if (!o) {
            // console.log("inside inner if")
            return ""
        }
        } else {
        // console.log("inside else")
        return "";
        }
    }
    return o;
    }

export function fundValueJson(payload, journeyId) {
    let fund = []
    let nVestFundValue = []
    let fundJson
    if (journeyId === "invest4GJourney") {
      fundJson = lookup['fundValueInvest4G']['fundMapping']
    }
    else {
      fundJson = lookup['fundValue']['fundMapping']
    }
    // logger.info(fundJson)
    if (!fundJson)
      return fund
    Object.keys(fundJson).forEach(path => {
      if (stringPath(payload, path)) {
  
        console.log(path)
        let fundName
        let value
        let allocationPercentage
        let sfinNo
        fundName = stringPath(payload, path)
        console.log(fundName, "fund name")
        if (fundName) {
          value = fundJson[path].fundOption
          allocationPercentage = stringPath(payload, fundJson[path].allocationPath)
          sfinNo = fundJson[path].sfinNo
          let obj = {
            "fundName": value,
            "allocationPercent": allocationPercentage,
            "sfinNo": sfinNo
          }
          let obj1 = {
            "fundId": value,
            "fundPercent": allocationPercentage
          }
          fund.push(obj)
          nVestFundValue.push(obj1)
        }
      }
      else {
        let value
        let allocationPercentage
        let sfinNo
        value = fundJson[path].fundOption
        allocationPercentage = parseInt("0")
        sfinNo = fundJson[path].sfinNo
        let obj1 = {
          "fundId": value,
          "fundPercent": allocationPercentage,
          "sfinNo": sfinNo
        }
        nVestFundValue.push(obj1)
      }
  
    })
    let fundValue = [
      fund,
      nVestFundValue
    ]
    return fundValue
  }

export function DataLayerIntegration (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState) {
    var allJourneyData = allJourneyDataResponse
    if (journeyState?.journeyIdFromStrapi === "guaranteedSavingsOption"){
        gspDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)
    }else if (journeyState?.journeyIdFromStrapi === "invest4GJourney"){
        invest4GDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)
    }else if (journeyState.journeyIdFromStrapi === "GAINjourney"){
        gainDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)
    }
}

export function transactionDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState) {
    if (journeyState?.journeyIdFromStrapi === "guaranteedSavingsOption"){
        gspTransactionDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)
    }else if (journeyState?.journeyIdFromStrapi === "invest4GJourney"){
        invest4GTransactionDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)
    }else if (journeyState.journeyIdFromStrapi === "GAINjourney"){
        gainTransactionDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)
    }
}
export const transformReceiptToTransaction = (receipt, journeyState) => {
    return {
      journeyId: journeyState.journeyId || null,
      applicationNumber: journeyState.applicationNo || null,
      status: receipt.receiptStatus || null,
      srcTraceId: receipt.srcTraceId || null,
      amount: receipt.amount || null,
      paymentTxnId: receipt.transactionNumber || null,
      source: receipt.receiptCreatedBy || null,
      paymentTxnDate: receipt.receiptDate ? new Date(Number(receipt.receiptDate) * 1000).toISOString() : null,
      paymentMethod: receipt.paymentMethod || null,
      receiptNo: receipt.receiptID || null,
      errMsg: null,
      mandateOpt: null,
      mandateTxnId: null,
      mandateTokenId: null,
      mandateId: null,
      mandate: null,
      mandateStatus: null,
      transactionNo: null,
      mercId: null,
    };
  };
